<div class="form-modal">
  <div class="form-modal__body">
	<a tabindex="0" (click)="onClose()" (keypress)="onClose()" class="close-modal"
		aria-label="Close organization edit form">
		<img src="./assets/img/icons-svg/close-icon.svg">
	</a>
    <div class="img-wrapper">
      <div class="clearfix"></div>
      <div class="title-wrapper">
        <h1>Edit user</h1>
      </div>
    </div>
	<popup-loader *ngIf="!isloaded"></popup-loader>
    <div class="form-wrapper" *ngIf="isloaded">
		<form novalidate [formGroup]="userEditForm" (ngSubmit)="doSave()">
			<div class="app-c-form-group">
				<label class="app-c-form--label" for="fullName">Full Name</label>
				<input class="app-c-form-control" type="text" formControlName="fullName" id="fullName" />
				<div class="error-message" *ngIf="f.fullName.touched && f.fullName.errors?.required">
					Fullname is required
				</div>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="email">Email</label>
				<input class="app-c-form-control" type="text" formControlName="email" id="email" />
				<div class="error-message" *ngIf="f.email.touched && !f.email.valid">
					Invalid email
				</div>
			</div>

			<div class="app-c-form-group">
				<label class="app-c-form--label" for="status" translate>Status</label>
				<select class="app-c-form-control" id="status" formControlName="status">
					<option value="approved">Approved</option>
					<option value="disabled">Disabled</option>
				</select>
			</div>

		<div class="icon-input" style="margin:10px 0px;">
			<label class="app-c-checkbox">
				<input type="checkbox" formControlName="notificationOn" />
				<span>Receive Notifications?</span>
			</label>
		</div>

		<div class="app-c-form-group">
			<label class="app-c-form--label" for="orgId" translate>Organization</label>
			<select class="app-c-form-control" id="orgId" formControlName="orgId">
				<option [value]="null">None</option>
				<option *ngFor="let org of organizations" [value]="org.id">{{org.name}}</option>
			</select>
		</div>

		<div class="app-c-form-group">
			<label class="app-c-form--label" for="timezone">Timezone</label>
			<select class="app-c-form-control" id="timezone" name="timezone" formControlName="timezone">
				<option value="">Select this user's timezone.</option>
				<option *ngFor="let timezone of timezones" [value]="timezone.key">{{timezone.text}}</option>
			</select>
		</div>

		<div class="app-c-form-group">
			<label class="app-c-form--label" for="roleId" translate>Role</label>
			<select class="app-c-form-control" id="roleId" formControlName="roleId">
				<option *ngFor="let role of roles" [value]="role.id">{{role.name}}</option>
			</select>
		</div>

		<p>
			<label class="app-c-checkbox">
				<input type="checkbox" formControlName="lockedRole" />
				<span translate>Lock role (useful in the case of sso)</span>
			</label>
		</p>

		<div class="fixed-footer">
			<button
				tabindex="0"
				class="btn-primary btn"
				[ngClass]="{ active: userEditForm.invalid }"
				[disabled]="userEditForm.invalid">
				Save
			</button>
		</div>
	  </form>
    </div>
  </div>
</div>
